import { Skeleton } from '@eureca/ui';
import { ConsultantsMenu } from '@/shared/consultants-menu/ConsultantsMenu';
import { RouteIcon } from './icons';

/**
 * Skeleton exibido enquanto o GET /jobs/:id está em voo na primeira
 * carga da subseção Informações Gerais (FR-042a). Mantém o layout do form
 * (header + 4 campos + footer) para evitar shift de paint quando os dados
 * chegam.
 */
export function JobEditInfoLoadingFallback() {
  return (
    <div className="flex min-h-dvh flex-row bg-muted">
      <ConsultantsMenu activeId="jobs" />

      <main className="flex flex-1 flex-col items-center gap-8 bg-card px-4 pt-8 pb-16 md:px-8">
        <div
          aria-busy="true"
          aria-label="Carregando vaga"
          data-testid="job-edit-info-loading"
          className="flex w-full max-w-[630px] flex-col gap-8"
        >
          <header className="flex flex-col gap-2">
            <div className="flex flex-row items-center gap-2">
              <div className="flex size-8 items-center justify-center rounded-md bg-secondary text-secondary-foreground">
                <RouteIcon className="size-4" />
              </div>
              <Skeleton className="h-9 w-48" />
            </div>
            <Skeleton className="h-6 w-40" />
          </header>

          <div className="flex flex-col gap-5">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="flex flex-col gap-2">
                <Skeleton className="h-4 w-24" />
                <Skeleton className={i === 2 ? 'h-40' : 'h-10'} />
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
